import { useLocation } from "react-router-dom";

export function useQueryParams() {
    const location = useLocation();
    const query = new URLSearchParams(location.search)
    const data: Record<string, string | null> = {}
    for (const key of query.keys()) data[key] = query.get(key)

    return data
}